import React, { useState } from "react";
import classes from "./InsightsMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Tabs } from "../../../stories/Tabs/Tabs";
import moment from "moment";
import { AnalyticsMobile } from "../Insights/analytics/analyticsMobile";
import { TransactionsMobile } from "../Insights/transactions/transactionsMobile";
import { useHistory, useLocation } from "react-router";
import MobileBottomTab from "../../../stories/MobileBottomTab/MobileBottomTab";
import {
  coachDemoImg,
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
} from "../../../constant/imagePath";

export const InsightsMobile = () => {
  const history = useHistory();

  const [menuItem, setMenuItem] = useState("insights");

  const [tabs, setTabs] = useState({ label: "Analytics" });

  const tabsdata = [{ label: "Analytics" }, { label: "Transactions" }];
  return (
    <div className={[classes.InsightsScreen].join(" ")}>
      <h2
        style={{
          ...Fonts.h2,
          color: Colors.neutralShadesOfNero,
          fontSize: "26px",
          lineHeight: "36px",
        }}
        className={[classes.mb8].join(" ")}
      >
        Insights
      </h2>
      <div className={[classes.mb16].join(" ")}>
        <Tabs
          tabsData={tabsdata}
          state={tabs}
          setState={setTabs}
          className={[classes.mb16].join(" ")}
        />
      </div>
      {tabs.label === "Analytics" && <AnalyticsMobile />}
      {tabs.label === "Transactions" && <TransactionsMobile />}

      <div className={classes.BottomTab}>
        <MobileBottomTab state={menuItem}
        />
      </div>
    </div>
  );
};
